import { type IButtonClassProps } from '@/Components/Buttons/Types'
import { twMerge } from 'tailwind-merge'

interface sizeProps {
  [key: string]: string
  xs: string
  sm: string
  med: string
  lg: string
  xlg: string
}

const sizes: sizeProps = {
  xs: 'text-xs py-1 px-2',
  sm: 'text-sm py-2 px-3',
  med: 'text-base p-3',
  lg: 'text-lg p-4',
  xlg: 'text-xl p-5'
}

export function getClassForSize (size: string = 'med'): string {
  if (sizes[size] !== undefined) {
    return sizes[size]
  }
  return sizes.med
}

interface makeClassNameProps {
  size?: string
  defaultClassName?: string
  className?: string
  error?: string
  errorClassName?: string
  disabled?: boolean
  extras?: Array<string | undefined>
}

export function makeClassName ({
  size,
  defaultClassName,
  className,
  error,
  errorClassName,
  disabled,
  extras
}: makeClassNameProps): string {
  const cl: string = className !== undefined ? className : ''
  const defaultCl: string = defaultClassName !== undefined ? defaultClassName : ''
  const errorClass: string = errorClassName !== undefined ? errorClassName : 'border-2 border-rose-600  focus:border-rose-600 focus:ring-offset-0'
  const hasError: boolean = error !== undefined
  return twMerge(
    size !== undefined ? getClassForSize(size) : '',
    defaultCl,
    extras?.filter(e => e !== undefined).join(' '),
    cl,
    hasError ? errorClass : ''
  )
}

export function createButtonClass ({
  className,
  defaultClassName = 'disabled:opacity-50 disabled:cursor-not-allowed font-bold border rounded',
  type = 'default',
  size = 'med'
}: IButtonClassProps): string {
  const types = {
    submit: 'bg-green-600 hover:bg-green-800 border-green-800 text-white',
    create: 'bg-blue-600 hover:bg-blue-800 border-blue-800 text-white',
    alert: 'bg-red-600 hover:bg-red-800 border-red-800 text-white',
    default: 'hover:border-slate-900 border-slate-500 text-slate-800 bg-white',
    dark: 'bg-slate-600 hover:bg-slate-800 border-slate-800 text-white',
    none: ''
  }

  return makeClassName({
    defaultClassName,
    size,
    extras: [types[type]],
    className
  })
}
